export const GuestEndpoints = {
  privacy: 'privacyPolicy',
  contact: 'contactUs',
  termsAndConditions: 'termsAndConditions',
} as const;

export type GuestEndpointValue = typeof GuestEndpoints[keyof typeof GuestEndpoints];